// assets
import '~/styles/index.scss';
import '~/img/thumb.jpg';
import '~/img/favicon.ico';
import '~/img/favicon-16x16.png';
import '~/img/favicon-32x32.png';
import '~/img/og-default.png';

import 'babel-polyfill';
import $ from 'jquery';
import accordion from '~/js/components/accordion';
import carousel from '~/js/components/carousel';
import observer from '~/js/components/observer';
import staggeredGrid from '~/js/components/staggered-grid';
import sticky from '~/js/components/sticky';
import scrollSizer from '~/js/components/scroll-sizer';
import pager from '~/js/components/pager';
import toggler from '~/js/components/toggler';
import search from '~/js/components/search';
import languageSwitcher from '~/js/components/language-switcher';

// TODO: should not be included in production
import gridOverlay from '~/js/components/grid-overlay';

// detect mobile
if (/Android|iPhone|iPad/i.test(navigator.userAgent)) {
    $('.page').addClass('page--mobile');
}


$(`.${accordion.markup.CONTAINER}`).each(function (i) {
    const $accordion = $(this);

    accordion({
        $e: $accordion,
        fallbackId: i,
        breakpoints: $accordion.data('breakpoints'),
        triggerLayout: $accordion.data('trigger')
    });
});

$(`.${carousel.markup.CONTAINER}`).each(function () {
    carousel({ $e: $(this) });
});

$(`.${observer.markup.CONTAINER}`).each(function () {
    observer({ $e: $(this) });
});

$(`.${staggeredGrid.markup.CONTAINER}`).each(function () {
    staggeredGrid({ $e: $(this) });
});

$(`.${sticky.markup.CONTAINER}`).each(function () {
    sticky({ $e: $(this) });
});

$(`.${scrollSizer.markup.CONTAINER}`).each(function () {
    scrollSizer({ $e: $(this) });
});

$(`.${pager.markup.CONTAINER}`).each(function () {
    const $pager = $(this);

    pager({
        $e: $pager,
        url: $pager.data('url'),
        targetSelector: $pager.data('target'),
        startIndex: $pager.data('start'),
        endIndex: $pager.data('end')
    });
});

$(`.${toggler.markup.CONTAINER}`).each(function () {
    const $toggler = $(this);

    toggler({
        $e: $(this),
        targetSelector: $toggler.data('target')
    });
});

$(`.${search.markup.CONTAINER}`).each(function () {
    search({ $e: $(this) });
});

gridOverlay();

$(`.${languageSwitcher.markup.CONTAINER}`).each(function () {
    languageSwitcher({ $e: $(this) });
});



// WEBPACK FOOTER //
// ./assets/js/index.js